import { render, staticRenderFns } from "./DownChev.vue?vue&type=template&id=1d0ef23a&"
import script from "./DownChev.vue?vue&type=script&lang=js&"
export * from "./DownChev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports